export const JUMBO_EVENTS = {
  PAGE_SHOWN: 'PAGE_SHOWN',
  PREVIEW_VIEWED: 'PREVIEW_VIEWED',
  BUTTON_CLICKED: 'BUTTON_CLICKED',
  TAB_CLICKED: 'TAB_CLICKED',
  SEARCHED: 'SEARCHED',
  OPTION_SELECTED: 'OPTION_SELECTED',
} as const

export const JUMBO_EVENT_LABELS = {
  PAGE_SHOWN: 'Page Shown',
  PREVIEW_VIEWED: 'Preview Viewed',
  BUTTON_CLICKED: 'Button Clicked',
  TAB_CLICKED: 'Tab Clicked',
  SEARCHED: 'Searched',
  OPTION_SELECTED: 'Option Selected',
} as const

export const PAGE_NAMES = {
  LANDING_PAGE: 'Landing Page',
  NEW_LANDING_PAGE: 'New Landing Page',
  HOME: 'Home',
  META_COLLAB: 'Meta Collab',
  NEW_AUDIENCE: 'New Audience',
  VIEW_AUDIENCE: 'View Audience',
  CLONE_AUDIENCE: 'Clone Audience',
  META_LINK: 'Meta Link',
  BRAND: 'Brand',
  USER_MANAGEMENT: 'User Management',
  FAQ: 'FAQ',
  BEST_PRACTICES: 'Best Practices',
} as const

export const PLATFORM_NAMES = {
  META: 'meta',
  GOOGLE: 'google',
} as const

export const PLATFORM_NAME_ENUM = {
  PLATFORM_NAME_UNSPECIFIED: 'PLATFORM_NAME_UNSPECIFIED',
  PLATFORM_NAME_META: 'PLATFORM_NAME_META',
  PLATFORM_NAME_GOOGLE: 'PLATFORM_NAME_GOOGLE',
} as const

export const WIDGET_TYPES = {
  UNSPECIFIED: 'WIDGET_TYPE_UNSPECIFIED',
  BUTTON: 'WIDGET_TYPE_BUTTON',
  MENU_ITEM: 'WIDGET_TYPE_MENU_ITEM',
  SEARCH: 'WIDGET_TYPE_SEARCH',
} as const

export const WIDGET_NAMES = {
  SUBMIT_AUDIENCE: 'Submit Audience',
  PREVIEW: 'Preview',
  LANDING_PAGE_NAME: 'Landing Page Name',
  CREATE_NEW: 'Create New',
  CREATE_LANDING_PAGE: 'Create Landing Page',
  META_ADS: 'Meta Ads',
  GOOGLE_ADS: 'Google Ads',
  SHOPPABLE_LINKS: 'Shoppable Links',
  REQUEST_OTP: 'Request OTP',
  VERIFY_OTP: 'Verify OTP',
  FAQ_SEARCH: 'FAQ Search',
  SUBMIT_BRAND_ACCESS: 'Submit Brand Access',
  SHOW_CATALOGUE: 'Show Catalogue',
  LINK_ON_META: 'Link on Meta',
  CHECK_STATUS: 'Check Status',
  VIDEO_GUIDE_BM_CHECK_STATUS: 'BM Check Status Video Guide',
  VIDEO_GUIDE_AD_ACCOUNT: 'Ad Account Video Guide',
  VERIFY_VIEW_ACCESS: 'Verify View Access',
} as const

export const EVENT_STATUS = {
  EVENT_STATUS_UNSPECIFIED: 'EVENT_STATUS_UNSPECIFIED',
  EVENT_STATUS_SUCCESS: 'EVENT_STATUS_SUCCESS',
  EVENT_STATUS_FAILURE: 'EVENT_STATUS_FAILURE',
} as const

export const USER_ENVIRONMENTS = {
  USER_ENVIRONMENT_UNSPECIFIED: 'USER_ENVIRONMENT_UNSPECIFIED',
  USER_ENVIRONMENT_PRODUCTION: 'USER_ENVIRONMENT_PRODUCTION',
  USER_ENVIRONMENT_STAGING: 'USER_ENVIRONMENT_STAGING',
  USER_ENVIRONMENT_DEVELOPMENT: 'USER_ENVIRONMENT_DEVELOPMENT',
} as const
